"use client"

import { Button } from "@/components/ui/button"
import AutoRefresh from "@/app/components/util/AutoRefresh"
import { useSearchParams } from "next/navigation"
import { openModal } from "@/app/components/Modal"

const shareModalQueryParam = "shareModal"

/**
 * This component is used to display the action buttons for a post.
 * It also contains a button to share the post.
 *
 * When share is clicked, the page is reloaded with a query param to show the share modal.
 * At the same time, the auto refresh is paused.
 *
 * Note: The PostRowDropdownMenuWrapper (if used) should be passed in as a child from an RSC
 * for faster loading.
 * @param param0
 * @returns
 */
export default function PostActionBtns({
  children,
}: {
  children: React.ReactNode
}) {
  const searchParams = useSearchParams()
  const isRefreshingEnabled = searchParams?.get(shareModalQueryParam) !== "true"
  return (
    <div className="flex flex-row gap-2">
      {isRefreshingEnabled && <AutoRefresh frequency={10000} />}

      {children}

      <Button variant="default" onClick={() => openModal(shareModalQueryParam)}>
        Share
      </Button>
    </div>
  )
}
